import { render, staticRenderFns } from "./MallDetail.vue?vue&type=template&id=58efc3c6"
import script from "./MallDetail.vue?vue&type=script&lang=js"
export * from "./MallDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports